import Header from "@/library/sections/headers/Header";
import { getConfig } from "@/storyblok/data";
import { storyblokEditable } from "@storyblok/react";

export default async function HeaderBlock() {
  const config_response = await getConfig();
  const config = config_response.content;
  if (!config) return null;
  

  const headerTitle = config.header_title;

  const links = config.header_links.map((link) => ({
    id: link._uid,
    text: link.text,
    url: link.link?.cached_url,
    subMenu:
      link.sub_menu?.map((subLink) => ({
        id: subLink._uid,
        text: subLink.text,
        url: subLink.link?.cached_url,
      })) || [],
  }));

  const logotype = config.header_logotype?.filename
  const logo = {
    src: logotype ? `${logotype}/m/47x48` : null,
    alt: config.header_logotype?.alt,
  };

  return (
    <div >
      <Header logo={logo} links={links} title={headerTitle} />
    </div>
  );
}